module.exports = __webpack_public_path__ + "img/cloud.907a93ac.svg";